import styled from "styled-components";



export const VerifyAchCardContainer = styled.div`
  min-width: 450px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const VerifyAchCardTitle = styled.div`
  font-size: var(--general-header-font-size);
  color: var(--font-color-blue002e5c);
  font-weight: var(--general-header-font-weight);
`;


export const VerifyAchCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
`

export const VerifyAchCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const VerifyAchCardText = styled.div`
  font-size: var(--general-large-body-font-size);
  color: var(--font-color-blue002e5c);
  font-weight: var(--general-large-body-font-weight);
  width: 90%;
`

export const VerifyAchCardOlList = styled.ol`

`

export const VerifyAchCardOlItem = styled.li`
  font-size: var(--general-large-body-font-size);
  color: var(--font-color-blue002e5c);
  font-weight: var(--general-large-body-font-weight);
  width: 90%;
`